export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center">
          联系我们
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          内容合作 · 版权反馈 · 意见投稿
        </p>

        <div className="mt-8 md:mt-10 max-w-2xl mx-auto">
          <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
              <div className="cursor-pointer group">
                <span className="w-12 h-12 mx-auto flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200">
                  <i className="ri-mail-line text-xl"></i>
                </span>
                <h3 className="mt-3 text-sm font-heading font-semibold text-foreground-900">
                  内容合作
                </h3>
                <p className="mt-1 text-xs text-foreground-400">
                  biz@meiguishipin.com
                </p>
              </div>
              <div className="cursor-pointer group">
                <span className="w-12 h-12 mx-auto flex items-center justify-center rounded-lg bg-secondary-50 text-secondary-500 group-hover:bg-secondary-500 group-hover:text-background-50 transition-all duration-200">
                  <i className="ri-copyright-line text-xl"></i>
                </span>
                <h3 className="mt-3 text-sm font-heading font-semibold text-foreground-900">
                  版权反馈
                </h3>
                <p className="mt-1 text-xs text-foreground-400">
                  dmca@meiguishipin.com
                </p>
              </div>
              <div className="cursor-pointer group">
                <span className="w-12 h-12 mx-auto flex items-center justify-center rounded-lg bg-accent-50 text-accent-500 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-200">
                  <i className="ri-chat-3-line text-xl"></i>
                </span>
                <h3 className="mt-3 text-sm font-heading font-semibold text-foreground-900">
                  意见投稿
                </h3>
                <p className="mt-1 text-xs text-foreground-400">
                  feedback@meiguishipin.com
                </p>
              </div>
            </div>
            <p className="mt-6 text-xs text-foreground-400 text-center">
              我们会在1-3个工作日内回复您的来件，感谢您对玫瑰视频的支持
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}